import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import ActivityListComponent from '@ciscospark/react-component-activity-list';

import {getActivityList} from './selectors';

function mapStateToProps(state, props) {
  return Object.assign({}, props, {
    activities: getActivityList(state, props)
  });
}

const ActivityList = connect(mapStateToProps)(ActivityListComponent);

const injectedPropTypes = {
  activities: PropTypes.array
};

ActivityList.propTypes = {
  activityFormatter: PropTypes.func,
  newMessagesMessage: PropTypes.string.isRequired,
  onActivityDelete: PropTypes.func.isRequired,
  onActivityFlag: PropTypes.func.isRequired,
  onActivityRetry: PropTypes.func.isRequired,
  ...injectedPropTypes
};

export default ActivityList;
